import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-tag-email-input',
  templateUrl: './tag-email-input.component.html',
  styleUrls: ['./tag-email-input.component.scss']
})
export class TagEmailInputComponent implements OnInit {
  entries: string[] = [];

  @Input()
  sendButtonText: string;

  @Input()
  showGrey = false;

  @Output()
  added = new EventEmitter<string>();

  @Output()
  removed = new EventEmitter<string>();

  @Output()
  sendButtonPressed = new EventEmitter<string[]>();

  get isValid() {
    return (
      this.entries != null &&
      this.entries.length > 0 &&
      this.entries.every(e => e != null && e.length > 0)
    );
  }

  ngOnInit() {}

  onFormSubmitHandler($event) {
    this.sendButtonPressed.emit(this.entries);
    this.entries = [];
    $event.preventDefault();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/_shared/tag-email-input/tag-email-input.component.ts